import {
  GET_ALL_FORMS_AND_FIELDS,
  GET_ALL_QUERIES,
  ADD_QUERY,
  SET_SELECTED_TABLE,
  SET_APPLIED_FIELDS_BY_TABLE,
  GET_ALL_QUERY_TABLE,
  SET_WHERE_CONDITION,
  SELECTED_FIELDS,
  REPORT_TYPES,
  GET_QUERY_TABLE,
  GET_DYNAMIC_QUERY,
  GET_QUERY,
  GET_REPORT_GENERATOR,
  UPDATE_QUERY,
  RESET_QUERY,
  SET_CONDITION_FIELDS,
} from '../types'

const INITIAL_STATE = {
  allFormsAndFields: [],
  allQueries: [],
  tableQuery: {},
  addQuery: [],
  selectedTables: {},
  appliedFieldsByTable: {},
  whereCondition: {},
  selectedFields: {},
  tabularReports: {},
  searchQueryValue: [],
  dynamicQuery: [],
  oneQuery: {},
  reportGenerator: [],
  updateQuery: [],
  conditionFields: [],
}

const queryReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_FORMS_AND_FIELDS:
      return {
        ...state,
        allFormsAndFields: payload.data,
      }
    case GET_ALL_QUERIES:
      return {
        ...state,
        allQueries: payload.data,
      }
    case GET_QUERY_TABLE:
      return {
        ...state,
        tableQuery: payload.data,
      }
    case ADD_QUERY:
      return {
        ...state,
        addQuery: payload?.data,
      }
    case RESET_QUERY:
      return {
        ...state,
        addQuery: [],
      }
    case GET_ALL_QUERY_TABLE:
      return {
        ...state,
        allqueryTable: payload.data,
      }
    case SET_SELECTED_TABLE:
      return {
        ...state,
        selectedTable: payload,
      }
    case SET_CONDITION_FIELDS:
      return {
        ...state,
        conditionFields: payload,
      }
    case SET_APPLIED_FIELDS_BY_TABLE: {
      state.appliedFieldsByTable[payload.tableName] = payload.fields
      return state
    }
    case SET_WHERE_CONDITION:
      return {
        ...state,
        whereCondition: payload,
      }
    case SELECTED_FIELDS:
      return {
        ...state,
        selectedFields: payload,
      }
    case REPORT_TYPES:
      return {
        ...state,
        tabularReports: payload,
      }
    case GET_DYNAMIC_QUERY:
      return {
        ...state,
        dynamicQuery: payload,
      }
    case GET_QUERY:
      return {
        ...state,
        oneQuery: payload.data,
      }
    case GET_REPORT_GENERATOR:
      return {
        ...state,
        reportGenerator: payload?.data,
      }
    case UPDATE_QUERY:
      return {
        ...state,
        updateQuery: payload,
      }
    default:
      return state
  }
}

export default queryReducer
